/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGeneratePdfMutationRequest, FilesControllerGeneratePdfMutationResponse, FilesControllerGeneratePdfPathParams, FilesControllerGeneratePdfHeaderParams, FilesControllerGeneratePdf400, FilesControllerGeneratePdf401, FilesControllerGeneratePdf403, FilesControllerGeneratePdf404 } from "../../models/filesController/FilesControllerGeneratePdf";

function getFilesControllerGeneratePdfUrl(id: FilesControllerGeneratePdfPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/files/${id}/pdf` as const }  
  return res
}

/**
 * @description Generates a PDF from the specified file using Nutrient Document Engine. Supports generating a PDF with an HTML based cover page and custom settings. Returns the generated PDF as application/pdf.
 * @summary Generate a PDF from a file
 * {@link /api/v1/files/:id/pdf}
 */
export async function filesControllerGeneratePdf(id: FilesControllerGeneratePdfPathParams["id"], headers: FilesControllerGeneratePdfHeaderParams, data?: FilesControllerGeneratePdfMutationRequest, config: Partial<RequestConfig<FilesControllerGeneratePdfMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<FilesControllerGeneratePdfMutationResponse, ResponseErrorConfig<FilesControllerGeneratePdf400 | FilesControllerGeneratePdf401 | FilesControllerGeneratePdf403 | FilesControllerGeneratePdf404>, FilesControllerGeneratePdfMutationRequest>({ method : "POST", url : getFilesControllerGeneratePdfUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...headers, ...requestConfig.headers } })  
  return res.data
}